import React from 'react';
import { Modal, Box, Typography, Grid, Button, Divider } from '@mui/material';
import {imgAPI} from '../../Api';
export default function ProductModal({ showTooltip, selectedProduct, setShowTooltip }) {
  const handleClose = () => {
    setShowTooltip(false);
  };
  return (
    <Modal open={showTooltip}  aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxWidth: 600,
        bgcolor: 'background.paper',
    
        boxShadow: 24,
        padding: 3,
        borderRadius: 2,
      }}>
        {selectedProduct && (
          <div>
            <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', fontSize: '1.5rem' }}>
              {selectedProduct.name} | {selectedProduct.code}
            </Typography>
            <Typography sx={{ fontStyle: 'italic', color: 'text.secondary' }}>{selectedProduct.category}</Typography>

            {/* Отображение изображения товара (если есть) */}
            {selectedProduct.photos ? (
              <img src={imgAPI.getImg(selectedProduct.photos)} alt={selectedProduct.name}  style={{ width: '100%', maxWidth: '300px', height: 'auto', borderRadius: '8px', marginBottom: '16px' }} />
            ) : (
              <Typography variant="body2" color="textSecondary">Изображение не доступно</Typography>
            )}

            {/* Описание товара */}
            <Typography variant="body1" sx={{ marginTop: 2 }}>
              {selectedProduct.description || 'Нет описания'}
            </Typography>

            <Divider sx={{ margin: '16px 0' }} />

            {/* Блок с ценами */}
            <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
              <Grid item xs={6}>
                <Typography variant="body2">Закупочная цена</Typography>
                <Typography variant="body1">{selectedProduct.purchase_price} ₽</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2">Оптовая цена</Typography>
                <Typography variant="body1">{selectedProduct.wholesale_price} ₽</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2">Цена на WB</Typography>
                <Typography variant="body1">{selectedProduct.wb_price} ₽</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2">Цена на Ozon</Typography>
                <Typography variant="body1">{selectedProduct.ozon_price} ₽</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2">Цена на Yandex</Typography>
                <Typography variant="body1">{selectedProduct.yandex_price} ₽</Typography>
              </Grid>
            </Grid>

            <Divider sx={{ margin: '16px 0' }} />

            {/* Дополнительные данные */}
            <Grid container spacing={2} sx={{ marginTop: 2 }}>
              <Grid item xs={6}>
                <Typography variant="body2">Артикул</Typography>
                <Typography variant="body1">{selectedProduct.sku}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2">Штрихкод</Typography>
                <Typography variant="body1">{selectedProduct.barcode}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2">Остатки на складе</Typography>
                <Typography variant="body1">{selectedProduct.stock}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2">Размеры</Typography>
                <Typography variant="body1">
                  {selectedProduct.width}x{selectedProduct.height}x{selectedProduct.length} мм
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2">Вес</Typography>
                <Typography variant="body1">{selectedProduct.weight} г</Typography>
              </Grid>
            </Grid>

            <Divider sx={{ margin: '16px 0' }} />

            <Button sx={{backgroundColor: "#6a1b9a"}} variant="contained" color="primary" fullWidth onClick={handleClose}>
              Закрыть
            </Button>
          </div>
        )}
      </Box>
    </Modal>
  );
}
